import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Tribal',
  slug: 'tribal',
  category: 'Tribal',
  date: '2025-04-30',
  image: 'https://dpnelson.com/wp-content/uploads/2025/04/blogs-5.webp',
  excerpt: 'If you prick us do we not bleed? If you tickle us do we not laugh? If you poison us do we not die? --Shylock, Merchant of Venice There is…',
  body: '', // STUB: copy body from src/content/site.ts — blog.posts entry with slug 'tribal'
}

export default post
